import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import {
	Button,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
} from "@material-ui/core";
import { SaveRounded } from "@material-ui/icons";

import PropTypes from "prop-types";
import { useHistory, useParams } from "react-router";
import { axiosWithAuth } from "../Helpers/AxiosWithAuth";

export const EditRecipe = (props) => {
	const { push } = useHistory();
	const { id } = useParams();

	const [recipe, setRecipe] = useState({
		recipe_id: id,
		recipe_title: "",
		recipe_source: "",
		image: "",
		user_id: 0,
		ingredients: "",
		instructions: "",
		category_id: 0,
	});

	const handleChange = (e) => {
		setRecipe({ ...recipe, [e.target.name]: e.target.value });
	};

	useEffect(() => {
		axiosWithAuth()
			.get(`api/recipes/${id}`)
			.then((res) => {
				setRecipe(res.data);
			})
			.catch((err) => {
				console.log(err);
			});
		//eslint-disable-next-line
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		axiosWithAuth()
			.put(`api/recipes/${id}`, recipe)
			.then((res) => {
				push(`/recipebook`);
			})
			.catch((err) => console.log(err));
	};

	return (
		<div>
			<div className="recipe-form">
				<h1> Edit {recipe.recipe_title} </h1>
				<form>
					<TextField
						id="recipe-title-input"
						name="recipe_title"
						label="Recipe Title"
						type="text"
						value={recipe.recipe_title}
						onChange={handleChange}
					></TextField>

					<TextField
						id="recipe-source-input"
						name="recipe_source"
						label="Recipe Source"
						type="text"
						value={recipe.recipe_source}
						onChange={handleChange}
					></TextField>

					<TextField
						id="recipe-image-input"
						name="image"
						label="ImageURL"
						type="text"
						value={recipe.image}
						onChange={handleChange}
					></TextField>

					<TextField
						id="recipe-ingrediants-input"
						name="ingredients"
						label="Ingredients"
						type="text"
						value={recipe.ingredients}
						onChange={handleChange}
					></TextField>

					<TextField
						id="recipe-instructions-input"
						name="instructions"
						label="Instructions"
						type="text"
						value={recipe.instructions}
						onChange={handleChange}
					></TextField>

					<FormControl sx={{ m: 1, minWidth: 80 }}>
						<InputLabel id="demo-simple-select-autowidth-label">
							Category
						</InputLabel>
						<Select
							labelId="demo-simple-select-autowidth-label"
							id="demo-simple-select-autowidth"
							name="category_id"
							value={recipe.category_id}
							onChange={handleChange}
							autoWidth
							label="Age"
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							<MenuItem value={0}>Select a Recipe Category</MenuItem>
							<MenuItem value={1}>Breakfast and Brunch Recipes</MenuItem>
							<MenuItem value={2}>Appetizer/Snack Recipes</MenuItem>
							<MenuItem value={3}>Main Dish Recipes</MenuItem>
							<MenuItem value={4}>Salad Recipes</MenuItem>
							<MenuItem value={5}>Dessert Recipes</MenuItem>
							<MenuItem value={6}>Healthy Recipes</MenuItem>
							<MenuItem value={6}>World Cuisine</MenuItem>
						</Select>
					</FormControl>

					<Button
						variant="contained"
						color="primary"
						size="large"
						className="button"
						startIcon={<SaveRounded />}
						onClick={handleSubmit}
					>
						Submit
					</Button>
				</form>
			</div>
		</div>
	);
};

EditRecipe.propTypes = {
	props: PropTypes,
};

const mapStateToProps = (state) => ({
	uesr: state.userReducer,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditRecipe);
